import React from 'react'
import { Box, useMediaQuery } from '@mui/material'
import { Outlet, useLocation } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { useAuth } from '../../context/AuthContext'
import { AnimatedPage } from '../animations/MotionContainers'

export const AppShell = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [sidebarOpen, setSidebarOpen] = React.useState(!isMobile)
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false)
  const location = useLocation()
  const { session } = useAuth()

  React.useEffect(() => {
    setSidebarOpen(!isMobile)
  }, [isMobile])

  React.useEffect(() => {
    if (isMobile) setSidebarOpen(false)
  }, [isMobile, location.pathname])

  const handleTopbarMenuClick = () => {
    if (isMobile) {
      setSidebarOpen((open) => !open)
      return
    }

    setSidebarCollapsed((collapsed) => !collapsed)
  }

  return (
    <Box className="suite-shell">
      <Sidebar
        open={sidebarOpen}
        mobile={isMobile}
        collapsed={sidebarCollapsed}
        onClose={() => setSidebarOpen(false)}
        onToggleCollapse={() => setSidebarCollapsed((collapsed) => !collapsed)}
        session={session}
      />

      <Box className="suite-main">
        <Topbar
          onMenuClick={handleTopbarMenuClick}
          sidebarCollapsed={sidebarCollapsed}
          sidebarOpen={sidebarOpen}
          mobile={isMobile}
          session={session}
        />

        <Box component="main" className="suite-content">
          <AnimatedPage>
            <Outlet />
          </AnimatedPage>
        </Box>
      </Box>
    </Box>
  )
}
